import { MyNumber } from '@/api/types';
import { DropdownOptions } from '@/types';

export const sortOptions: DropdownOptions<MyNumber['status'] | 'all'> = [
    {
        value: 'all',
        label: 'Все',
    },
    {
        value: 'active',
        label: 'Активные',
    },
    {
        value: 'inactive',
        label: 'Неактивные',
    },
    {
        value: 'delivery',
        label: 'Доставка',
    },
    {
        value: 'disabled',
        label: 'Отключен',
    },
];
